// Exact track labels used in the final Spring 2026 project results.
export const FINAL_RESULT_TRACKS = [
  "Про Партнеров 1",
  "Про Партнеров 2 (Архитектура)",
  "Про Стартапы",
  "Про Исследования",
  "Про Общество",
  "Про Организацию",
];
